import React, { Component } from 'react';
import { Row, Col, Icon } from 'antd';

export default class Code457 extends Component {
    constructor(props) { super(props); }
    render() {
        const { styleProps } = this.props;
        return (
            <div>
                <div {...styleProps.textDiv}>{'Unable to login.'}</div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '8px' }}>
                    <Col span={14}>
                        <div style={{ fontStyle: 'italic' }}>
                            {'This account has been locked. For further assistance, '}
                            {'please contact FTSP Help at '}
                            <span style={{ fontWeight: 'bold' }}>
                                {'FTSP.Help@dhs.gov'}
                            </span>
                            {'.'}
                        </div>
                    </Col>
                </Row>
                <div {...styleProps.indicatorDiv}>
                    <Icon type='warning' style={{ color: 'rgb(240, 180, 14)', fontSize: '40px' }} />
                </div>
            </div>
        );
    }
}
